import React from "react";
import { Menu, Layout, MenuProps } from 'antd';
import './main.css';
import 'antd/dist/reset.css';
import Header from "./header";
import { Outlet, useNavigate } from "react-router-dom";
import { observer } from "mobx-react";
import TicketCreateBar from "./components/ticket/ticket-create-bar";
import Subjects from "./models/subjects";

const { Footer, Sider, Content } = Layout;

const Main: React.FC = () => {

    type MenuItem = Required<MenuProps>['items'][number];

    function getItem(
        label: React.ReactNode,
        key: React.Key,
        icon?: React.ReactNode,
        children?: MenuItem[],
        type?: 'group',
    ): MenuItem {
        return {
            key,
            icon,
            children,
            label,
            type,
        } as MenuItem;
    }

    const items: MenuItem[] = [
        getItem('Математика ЕГЭ', 'math', null, [
            getItem('Список задач', '/math/tasks/list'),
            getItem('Добавить задачи', '/math/tasks/add'),
            getItem('Создание варианта', '/math/tickets/add'),
            getItem('Список вариантов', '/math/tickets/list'),
            getItem('Ученики', '/math/students/list'),
            getItem('Словари', '/math/dictionaries')
        ]),
        getItem('Физика ЕГЭ', 'physic', null, [
            getItem('Список задач', '/physic/tasks/list'),
            getItem('Добавить задачи', '/physic/tasks/add'),
            getItem('Создание варианта', '/physic/tickets/add'),
            getItem('Список вариантов', '/physic/tickets/list'),
            getItem('Ученики', '/physic/students/list'),
            getItem('Словари', '/physic/dictionaries')
        ])
    ];

    const onClick: MenuProps['onClick'] = (e) => {
        localStorage.setItem("place", e.key);
        navigate(e.key);
    };

    const navigate = useNavigate();

    const place = localStorage.getItem('place');
    const subject = place == null ? Subjects.MATH.toLowerCase() : place.split('/')[1];

    return (
        <Layout>
            <Header />
            <Layout hasSider style={{ minHeight: '93vh' }}>
                <Sider theme="dark" width="15%" collapsed={false}>
                    <Menu mode="inline"
                        theme="dark"
                        onClick={onClick}
                        defaultSelectedKeys={[place == null ? '/math/tasks/list' : place]}
                        defaultOpenKeys={[subject]}
                        items={items}>
                    </Menu>
                </Sider>
                <Layout>
                    <TicketCreateBar subject={subject.toUpperCase() as Subjects} />
                    <Content className="show__content">
                        <Outlet />
                    </Content>
                    <Footer className="footer">
                        <div>Darshana ©2025 Created by linnenson</div>
                        <div>Icon author: <a href="https://www.flaticon.com/ru/authors/good-ware" title="Good Ware">Good Ware</a> from <a href="https://www.flaticon.com/ru/" title="Flaticon">www.flaticon.com</a></div>
                    </Footer>
                </Layout>
            </Layout>
        </Layout>
    );
};

export default observer(Main);

// https://gist.github.com/VesperDev/e233115469a6c53bb96443f66385aa22